var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetaMask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      display: "block",
      position: "relative"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5071 1L17.801 9.69426L19.9658 4.56476L29.5071 1Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.48315 1L14.0951 9.77661L12.0362 4.56476L2.48315 1Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2945 21.1528L22.1768 25.9294L28.8475 27.7647L30.7651 21.2587L25.2945 21.1528Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.24731 21.2587L3.15323 27.7647L9.82393 25.9294L6.70623 21.1528L1.24731 21.2587Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44821 13.0817L7.58936 15.8935L14.213 16.1876L13.9777 9.06982L9.44821 13.0817Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5428 13.083L17.9545 8.98877L17.8015 16.1889L24.4134 15.8948L22.5428 13.083Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82324 25.9293L13.7998 23.9881L10.3644 21.3057L9.82324 25.9293Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1887 23.9881L22.177 25.9293L21.6241 21.3057L18.1887 23.9881Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1748 25.9285L18.1865 23.9873L18.5042 26.5873L18.4689 27.6815L22.1748 25.9285Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82104 25.9285L13.527 27.6815L13.5035 26.5873L13.7976 23.9873L9.82104 25.9285Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5885 19.5891L10.2708 18.6126L12.612 17.542L13.5885 19.5891Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4006 19.5891L19.3771 17.542L21.7301 18.6126L18.4006 19.5891Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82253 25.9289L10.3872 21.1523L6.70483 21.2582L9.82253 25.9289Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6113 21.1523L22.176 25.9289L25.2937 21.2582L21.6113 21.1523Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4117 15.8936L17.7998 16.1877L18.4116 19.5877L19.3881 17.5406L21.741 18.6112L24.4117 15.8936Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M10.27 18.6112L12.623 17.5406L13.5877 19.5877L14.2113 16.1877L7.58765 15.8936L10.27 18.6112Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5874 15.8936L10.3639 21.3054L10.2698 18.6112L7.5874 15.8936Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7402 18.6112L21.6226 21.3054L24.4108 15.8936L21.7402 18.6112Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2112 16.188L13.5876 19.588L14.3641 23.5999L14.5406 18.3174L14.2112 16.188Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7981 16.188L17.4805 18.3057L17.6216 23.5999L18.4099 19.588L17.7981 16.188Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4128 19.5888L17.6245 23.6006L18.1892 23.9889L21.6246 21.3065L21.7422 18.6123L18.4128 19.5888Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2708 18.6123L10.3649 21.3065L13.8002 23.9889L14.3649 23.6006L13.5885 19.5888L10.2708 18.6123Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4697 27.6827L18.505 26.5885L18.2109 26.3297H13.7755L13.5049 26.5885L13.5285 27.6827L9.82251 25.9297L11.1166 26.9885L13.7402 28.8121H18.2462L20.8815 26.9885L22.1756 25.9297L18.4697 27.6827Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1898 23.9888L17.625 23.6006H14.3662L13.8014 23.9888L13.5073 26.5889L13.7779 26.33H18.2133L18.5074 26.5889L18.1898 23.9888Z",
    fill: "#161616",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9999 10.259L31 5.45889L29.5058 1L18.188 9.40013L22.541 13.0825L28.694 14.8826L30.0588 13.2943L29.4705 12.8708L30.4117 12.0119L29.6823 11.4472L30.6235 10.7296L29.9999 10.259Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.45889L2.00002 10.259L1.36471 10.7296L2.3059 11.4472L1.58824 12.0119L2.52944 12.8708L1.94119 13.2943L3.29415 14.8826L9.4472 13.0825L13.8002 9.40013L2.48238 1L1 5.45889Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6945 14.883L22.5414 13.083L24.4121 15.8948L21.6238 21.3067L25.2944 21.2596H30.7651L28.6945 14.883Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44696 13.083L3.29392 14.883L1.24683 21.2596H6.70574L10.3646 21.3067L7.5881 15.8948L9.44696 13.083Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8009 16.1887L18.1892 9.40031L19.9774 4.56494H12.0361L13.8009 9.40031L14.2126 16.1887L14.3538 18.3299L14.3656 23.6005H17.6245L17.648 18.3299L17.8009 16.1887Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaMask);
export default __webpack_public_path__ + "static/media/metaMask.c23aeb7924b9cda6dcb8d896791ce142.svg";
export { ForwardRef as ReactComponent };